import list from 'src/modules/eventTimeZone/list/eventTimeZoneListReducers';
import form from 'src/modules/eventTimeZone/form/eventTimeZoneFormReducers';
import view from 'src/modules/eventTimeZone/view/eventTimeZoneViewReducers';
import destroy from 'src/modules/eventTimeZone/destroy/eventTimeZoneDestroyReducers';
import importerReducer from 'src/modules/eventTimeZone/importer/eventTimeZoneImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
